import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    autosubmit: { type: Boolean, default: false },
    requiresFlag: { type: String, default: '' },
    debounce: { type: Number, default: 0 },
    minChars: { type: Number, default: 0 }
  }

  initialize() {
    this.lastSubmitted = null
    this.debounceTimer = null
  }

  connect() {
    if (!this.autosubmitValue) return
    if (this.requiresFlagValue && sessionStorage.getItem(this.requiresFlagValue) !== '1') return
    if (this.requiresFlagValue) sessionStorage.removeItem(this.requiresFlagValue)
    this.element.requestSubmit()
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
  }

  submit(event) {
    if (!this.#shouldSubmit(event)) return

    if (this.debounceValue > 0) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => this.element.requestSubmit(), this.debounceValue)
    } else {
      this.element.requestSubmit()
    }
  }

  #shouldSubmit(event) {
    if (this.minCharsValue <= 0) return true

    const input = event?.target
    if (!input || typeof input.value !== 'string') return true

    const value = input.value.trim()
    const previous = this.lastSubmitted ?? ''
    this.lastSubmitted = value

    if (value.length === 0) return true

    if (value.length < this.minCharsValue && previous.length < this.minCharsValue) return false
    return true
  }
}
